import { Inject, NgModule } from "@angular/core";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { APP_CONFIG, IAppConfig } from "@gtmhub/env";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { PrivacyNoticeComponent } from "./privacy-notice.component";

declare global {
  interface Window {
    pdfWorkerSrc: string;
  }
}

@NgModule({
  imports: [LocalizationModule, UiButtonModule, PdfViewerModule],
  declarations: [PrivacyNoticeComponent],
  exports: [PrivacyNoticeComponent],
})
export class PrivacyNoticeModule {
  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig) {
    const cdnUrl = appConfig.cdnStorage.enabled ? appConfig.cdnStorage.url || "https://cdnstaging.quantivestatic.com" : "";
    window.pdfWorkerSrc = `${cdnUrl}/dist/lib/pdfjs/pdf.worker.min.js`;
  }
}
